'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PromptablePropInterface = {
  onConfirm: _propTypes2.default.func.isRequired,
  onReject: _propTypes2.default.func.isRequired
};

exports.default = PromptablePropInterface;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/decorators/PromptablePropInterface.js
// module id = 544
// module chunks = 177